import { render, staticRenderFns } from "./detailProject.vue?vue&type=template&id=a0b0d0f0&scoped=true&"
import script from "./detailProject.vue?vue&type=script&lang=js&"
export * from "./detailProject.vue?vue&type=script&lang=js&"
import style0 from "./detailProject.vue?vue&type=style&index=0&id=a0b0d0f0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b0d0f0",
  null
  
)

export default component.exports